import { render } from "./MetadataNavigationCom.vue?vue&type=template&id=aa22dcc6"
import script from "./MetadataNavigationCom.vue?vue&type=script&lang=js"
export * from "./MetadataNavigationCom.vue?vue&type=script&lang=js"

import "./MetadataNavigationCom.vue?vue&type=style&index=0&id=aa22dcc6&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__